import {
  createSelector,
} from 'reselect';

import {
  getResourceMappedList,
} from './resources';

export const getClientPro = createSelector(
  getResourceMappedList('pros'),
  pros => pros.find(p => p.live),
);
